<template>
  <div>
    <br>
    <Affiliate-Companies-Card/>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>

</style>